<!--充值明细-->
<template>
  <div class="home-main agent">
    <div class="main">
      <div class="main_title">
        <span class="title-cn">离线许可</span>
        <span class="title-en">/Offline</span>
        <div class="main-title-right">
          <el-button size="medium" class="primary" @click="offlineOpen">生成离线许可</el-button>
        </div>
      </div>
      <!--筛选部分start-->
      <div class="agent-selector">
        <div class="select-item">
          <p>授权码</p>
          <el-input v-model="searchOption.auth_code" class="select-input" size="small" clearable></el-input>
        </div>
        <div class="select-item">
          <p>客户名称</p>
          <el-input v-model="searchOption.auth_name" class="select-input" size="small" clearable></el-input>
        </div>
        <div class="select-item">
          <p>machineid</p>
          <el-input v-model="searchOption.code" class="select-input" size="small" clearable></el-input>
        </div>
        <div class="select-item" v-if="isMaintainer()">
          <p>伙伴用户名</p>
          <el-input v-model="searchOption.username" class="select-input" size="small" clearable></el-input>
        </div>
        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="restSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="agent-main-line"></div>

      <!--订单列表start-->
      <div class="agent-main-list">
        <el-table height="100%" :data="tableData" style="width: 100%" stripe>
          <el-table-column width="40"> </el-table-column>
          <el-table-column label="绑定授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权客户名称">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.user_loginname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴名称">
            <template slot-scope="scope">
              <span>{{ scope.row.user_company }}</span>
            </template>
          </el-table-column>
          <el-table-column label="machineid">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最后更新时间">
            <template slot-scope="scope">
              <span>{{ scope.row.update_time }}</span>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column label="操作" width="260" class="table-status">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="updateOffline(scope.$index, scope.row)">更新离线许可</el-button>
              <el-button size="mini" type="primary" @click="downloadOffline(scope.$index, scope.row)">下载离线许可</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--订单列表end-->
      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>

      <!-- 生成离线许可 -->
      <el-dialog title="生成离线许可" :visible.sync="offlineVisable" width="506px">
        <el-form :model="offlineForm" ref="offlineForm" :rules="offlineFormRules">
          <el-form-item label="绑定授权码" prop="auth_code" :label-width="formLabelWidth">
            <el-input v-model="offlineForm.auth_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="machineid" prop="code" :label-width="formLabelWidth">
            <el-input v-model="offlineForm.code" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hideOfflineDialog">取 消</el-button>
          <el-button class="primary" @click="offlineFormSubmit">提 交</el-button>
        </div>
      </el-dialog>
      <!-- 生成离线许可 -->

    </div>
  </div>
</template>

<script>
import { createGetUrlParams } from "@/utils/url";
import { setCode, getLicense, getModuleOfflineList } from "@/api/offlineAuth";
import { param } from "express/lib/request";
export default {
  data() {
    return {
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      /*筛选条件-充值时间start*/
      searchOption: {
        code: "", // 授权码
        user: "", // 客户名称
        machineid: "", //machineid
        username:""
      },
      /*表格数据start*/
      tableData: [],
      /*表格数据end*/
      formLabelWidth: "110px",

      /*权限开通start*/
      offlineVisable: false,
      offlineForm: {
        code: "",
        auth_code: ""
      },
      offlineFormRules: {
        code: [
          {
            required: true,
            message: "请输入machineid",
            trigger: "blur",
          },],
        auth_code: [
          {
            required: true,
            message: "请输入授权码",
            trigger: "blur",
          },],
      },
    };
  },
  mounted() {
    this.getTransactionData();
  },
  methods: {
    showOfflineDialog() {
      this.offlineVisable = true
    },
    hideOfflineDialog() {
      this.offlineForm = {
        code: "",
        auth_code: ""
      },
        this.offlineVisable = false;
    },
    // 生成离线许可
    offlineFormSubmit() {
      setCode(this.offlineForm).then(res => {
        this.hideOfflineDialog();
        this.offlineForm = {
          code: "",
          auth_code: ""
        }
      }).catch(error => {

      })
    },

    offlineOpen() {
      this.showOfflineDialog()
    },
    // 更新离线授权
    updateOffline(index, row) {
      getLicense({ auth_code: row.auth_code }).then(res => {
        this.$message.success("更新离线许可成功")
      }).catch(err => {
        this.$message.error("更新离线许可失败")
      })
    },
    // 下载离线授权
    downloadOffline(index, row) {
      // TODO
      // console.log(row);
      // row.auth_code
      getLicense({ auth_code: row.auth_code }).then(res => {
        location.href = res.url
      }).catch(err => {

      })
    },
    isMaintainer() {
      // return false
      if (this.$store.getters.userInfo) {
        if (this.$store.getters.userInfo.is_superuser) return true
        return this.$store.getters.userInfo.is_maintainer
      }
      return false
    },
    download(url, name) {
      const a = document.createElement('a');
      a.preventDefault();
      a.href = url;
      a.download = name
      a.click()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getTransactionData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getTransactionData();
      }
    },
    getTransactionData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,

      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getModuleOfflineList(result.data)
          .then((response) => {
            console.log(response, '4565645641');

            this.loading = false;
            this.pagination.total = response.count | 0;
            this.tableData = response.results;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    search() {
      this.restPage(true);
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
        
      };
      params = Object.assign(params, this.searchOption)
      let result = createGetUrlParams(params);

      if (result.success) {
        this.loading = true;
        getModuleOfflineList(result.data)
          .then((response) => {
            this.tableData = response.results;
            this.pagination.total = response.count;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    restSearch() {
      for (const key in this.searchOption) {
        if (this.searchOption.hasOwnProperty(key)) {
          this.searchOption[key] = "";
        }
      }
      this.restPage(true);
      this.getTransactionData();
    },
  },
};
</script>

<style lang="scss">
@import url("../../assets/css/system.css");

.agent {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector {
      height: 37px !important;
      background: #fff;

      .selector-center {
        margin-left: 0 !important;
        width: 400px !important;
      }
    }

    .group {
      p {
        margin: 10px 15px 10px 5px !important;
        float: left !important;
        width: 80px !important;
        height: 32px !important;
        line-height: 32px !important;
        text-align: right !important;
      }
    }

    .group .el-input {
      float: left !important;
      margin: 10px 0px !important;
      width: 200px !important;
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }

    .selector-right {
      height: 100% !important;
      line-height: 50px !important;
    }
  }
}

/*筛选部分start*/
.agent-selector {
  padding: 18px 0px 20px 24px !important;
  min-width: 980px !important;
  font-size: 12px !important;
  height: 32px !important;
  background: #fff;
}

.select-item {
  float: left;
  margin-right: 34px;

  .el-select {
    width: auto;
  }
}

.select-item .el-date-editor {
  width: 180px;
}

.select-item .el-input__inner {
  padding-right: 0px;
}

.select-item p {
  padding-right: 10px;
  float: left;
  height: 32px;
  line-height: 32px;
  text-align: right;
}

.select-input {
  float: left;
  width: 160px;
}

.selcet-product .el-input__inner {
  width: 150px;
  height: 32px;
  line-height: 32px;
}

.el-select-dropdown__list {
  padding: 6px 0px 22px 0px;
}

.el-select-dropdown span {
  font-size: 12px;
}

/*筛选部分end*/

.agent-main-line {
  width: 100%;
  border-bottom: 1px solid #ededed;
}

/*订单列表start*/
.agent-main-list {
  min-width: 1100px;
  flex-grow: 1;
  height: 50%;
  /*margin-top: 10px;*/
  /*margin:35px 30px 0px 30px;*/
}

.agent-main-list .cell span {
  font-size: 12px;
}

/*订单列表end*/
.account-table {
  .el-input__inner {
    height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/offlineProduct.vue